import { useEffect, useState } from "react";
import type { BlogApiPost } from "../services/blogService";
import { fetchNewsletterPosts } from "../services/newsletterService";

export const useNewsletterPosts = (page: number, pageSize: number) => {
  const [posts, setPosts] = useState<BlogApiPost[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const loadPosts = async () => {
      setLoading(true);
      try {
        const { posts: data, totalCount: count } = await fetchNewsletterPosts({
          page,
          pageSize,
        });
        if (isMounted) {
          setPosts(data);
          setTotalCount(count);
        }
      } catch (error) {
        console.error("Failed to load newsletter posts", error);
        if (isMounted) {
          setPosts([]);
          setTotalCount(0);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadPosts();

    return () => {
      isMounted = false;
    };
  }, [page, pageSize]);

  return { posts, totalCount, loading };
};
